import React, { useEffect, useState } from "react";
import { Container, Table, Row, Col, Form, Pagination, Button, } from "react-bootstrap";
import {
    FiPlus, FiSearch, FiEdit, FiHome,
    FiChevronRight,
} from "react-icons/fi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getstandardfees } from "../../store/slices/fees";


export default function FeesList() {

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const { feeslist = [], loading, error } = useSelector(
        (state) => state.fees || {}
    );


    const [searchStandard, setSearchStandard] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(25);


    useEffect(() => {
        dispatch(getstandardfees());
    }, [dispatch]);


    useEffect(() => {
        setCurrentPage(1);
    }, [searchStandard]);

    /* search filter ---------- */
    const filteredData = feeslist.filter((item) =>
        item.standardId?.name
            ?.toLowerCase()
            .includes(searchStandard.toLowerCase())
    );

    /* ---------- pagination  */
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredData.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    const navigatetoeditpage = (id) => {

        navigate(`/institute/edit-fees/${id}`)
        console.log("fees details id", id)

    }


    if (loading) return <p className="p-4">Loading...</p>;
    if (error) return <p className="p-4 text-danger">{error}</p>;

    return (
        <Container fluid>
            {/* ---------- Header */}
            <div className="page-header">
                <div className="breadcrumb-section">

                    <div className="breadcrumb-left">
                        <div className="home-icon">
                            <FiHome />
                        </div>

                        <FiChevronRight className="separator" />

                        <Link to="/institute/home">Home</Link>

                        <FiChevronRight className="separator" />

                        <span className="active">Fees</span>
                    </div>

                    <Link
                        to="/institute/add-fees"
                        className="add-btn"
                    >
                        <FiPlus />
                        Add Fees
                    </Link>

                </div>
            </div>

            {/*  Card ---------- */}
            <div className="staff-card">


                {/* ---------- Table */}
                <div className="table-responsive">
                    <Table className="staff-table align-middle">
                        <thead>
                            <tr>

                                <th>#</th>
                                <th>Standard</th>
                                <th>Session</th>
                                <th>Fees Category</th>
                                <th>Total Amount</th>
                                <th>Term</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {paginatedData.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center">
                                        No fees data found
                                    </td>
                                </tr>
                            ) : (
                                paginatedData.map((item, index) => (

                                    <tr key={item._id}>

                                        <td>{startIndex + index + 1}</td>

                                        <td>{item.standardId?.name}</td>

                                        <td>{item.session}</td>

                                        <td>
                                            {item.feeDetails.map((f, i) => (
                                                <div key={i}>{f.feeCategoryId?.name}</div>
                                            ))}
                                        </td>

                                        <td>
                                            {item.feeDetails.map((f, i) => (
                                                <div key={i}>₹ {f.amount}</div>
                                            ))}
                                        </td>

                                        <td>
                                            {item.feeDetails.map((f) =>
                                                f.paymentBreakdown.map((p, i) => (
                                                    <div key={i} >
                                                        {p.name} – ₹ {p.amount},
                                                    </div>
                                                ))
                                            )}
                                        </td>

                                        <td className="text-center">
                                            <button
                                                className="edit-btn"
                                                onClick={() => navigatetoeditpage(item._id)}
                                            >
                                                <FiEdit style={{ fontSize: '15px' }} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
                {/*  >> Pagination ---------- */}
                <div className="d-flex flex-row-reverse my-3">
                    <Pagination>
                        <Button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((p) => p - 1)}
                            style={{ background: "transparent", color: "#8451ff", marginRight: "2px", textAlign: "center", borderRadius: "15px" }}
                        >
                            <IoIosArrowBack />
                        </Button>
                        <Button
                            active
                            disabled
                            style={{ marginRight: "2px", borderRadius: "20px" }}
                        >
                            {currentPage}
                        </Button>
                        <Button
                            disabled={currentPage === totalPages || paginatedData.length === 0}
                            onClick={() => setCurrentPage((p) => p + 1)}
                            style={{ background: "transparent", color: "#8451ff", marginRight: "2px", textAlign: "center", borderRadius: "15px" }}
                        >
                            <IoIosArrowForward />
                        </Button>
                    </Pagination>
                </div>
            </div>
        </Container >
    );
}
